import CMPage from './CMPage';

export default CMPage;
